import angular from 'angular';

import Component from './shutoff.component';
import Service from './shutoff.service';


export default angular
  .module('petroCloud.dashboard.shutoffPanel', [])
  .component(Component.name, Component)
  .service('ShutoffThresholdPanelService', Service)
  .name;
